import { Link, useLocation, useNavigate } from "react-router-dom";
import { MouseEvent } from "react";
import { cn } from "@/lib/utils";
import logoFist from "@/assets/logo-fist.png";

export const Logo = ({
  className,
  iconSize = "w-11 h-11",
  textSize = "text-xl",
}: {
  className?: string;
  iconSize?: string;
  textSize?: string;
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      e.preventDefault();
      navigate("/");
      // scroll after navigation paints
      requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: "smooth" }));
    }
  };

  return (
    <Link to="/" onClick={handleClick} className={cn("flex items-center gap-2.5 group", className)}>
      <div
        className={cn(
          "relative grid place-items-center rounded-xl bg-background border-2 border-neon-green overflow-hidden glow-green transition-transform group-hover:scale-105",
          iconSize
        )}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-neon-green/25 via-transparent to-neon-purple/15" />
        <img
          src={logoFist}
          alt="PunchInk fist logo"
          width={64}
          height={64}
          className="relative w-[88%] h-[88%] object-contain drop-shadow-[0_0_10px_hsl(var(--neon-green))]"
        />
      </div>
      <span className={cn("font-display font-black tracking-[0.02em] leading-none", textSize)}>
        <span className="text-neon-green drop-shadow-[0_0_8px_hsl(var(--neon-green)/0.8)]">PUNCH</span>
        <span className="text-neon-purple drop-shadow-[0_0_8px_hsl(var(--neon-purple)/0.8)]">INK</span>
      </span>
    </Link>
  );
};
